import React, { useEffect, useState, Component } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { PackageIcon, ArrowRightIcon, CheckIcon, XIcon, TrendingUpIcon, BoxesIcon } from 'lucide-react';
export const ProductBundlesPage = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-5147">
      <Navbar scrolled={scrolled} data-id="element-5148" />
      <main className="pt-24 pb-20" data-id="element-5149">
        <div className="container mx-auto px-4 md:px-6" data-id="element-5150">
          <div className="max-w-4xl mx-auto" data-id="element-5151">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 md:p-12 mb-12 text-white relative overflow-hidden" data-id="element-5152">
              <div className="absolute right-0 bottom-0 opacity-10" data-id="element-5153">
                <BoxesIcon className="h-64 w-64" data-id="element-5154" />
              </div>
              <div className="relative z-10" data-id="element-5155">
                <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-5156">
                  Product Bundles That Sell
                </h1>
                <p className="text-xl opacity-90 max-w-3xl" data-id="element-5157">
                  Discover how to create irresistible product bundles that
                  increase your average order value and provide more value to
                  your customers.
                </p>
              </div>
            </div>
            {/* Main content */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 md:p-10 shadow-sm mb-10" data-id="element-5158">
              <h2 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-6" data-id="element-5159">
                The Power of Product Bundling
              </h2>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6" data-id="element-5160">
                Product bundling is a proven strategy that can significantly
                boost your revenue and provide more value to your customers. By
                combining complementary digital products into a single package,
                you can increase your average order value while giving customers
                a better deal than if they purchased items separately.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6" data-id="element-5161">
                Studies show that well-designed bundles can increase revenue by
                15-30% compared to selling products individually, while also
                improving customer satisfaction through the perception of
                getting more value.
              </p>
              <div className="border-l-4 border-[#2DB489] dark:border-[#4ED1A0] pl-6 my-8 py-2" data-id="element-5162">
                <p className="text-lg font-medium text-gray-800 dark:text-[#F8FAF9] italic" data-id="element-5163">
                  "The key to successful bundling isn't just combining
                  products—it's creating packages that solve broader problems
                  for specific customer segments."
                </p>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mt-12 mb-6" data-id="element-5164">
                Types of Effective Digital Product Bundles
              </h2>
              <div className="mb-8" data-id="element-5165">
                <h3 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9] mb-4 flex items-center" data-id="element-5166">
                  <span className="bg-[#2DB489] dark:bg-[#4ED1A0] text-white w-8 h-8 rounded-full flex items-center justify-center mr-3" data-id="element-5167">
                    1
                  </span>
                  Complementary Product Bundles
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD] mb-4 ml-11" data-id="element-5168">
                  Combine products that work well together to solve a larger
                  problem or create a complete solution.
                </p>
                <div className="ml-11 bg-gray-50 dark:bg-[#1A3330] p-5 rounded-lg mb-6" data-id="element-5169">
                  <p className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-3" data-id="element-5170">
                    Example:
                  </p>
                  <div className="flex flex-col md:flex-row gap-4" data-id="element-5171">
                    <div className="flex-1 bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-5172">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-5173">
                        Website Template Bundle
                      </p>
                      <ul className="text-sm text-gray-600 dark:text-[#B0C1BD] space-y-1" data-id="element-5174">
                        <li data-id="element-5175">• Main website template</li>
                        <li data-id="element-5176">• Matching email newsletter template</li>
                        <li data-id="element-5177">• Social media graphics pack</li>
                        <li data-id="element-5178">• Brand style guide template</li>
                      </ul>
                      <p className="mt-3 text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-5179">
                        Complete brand presence across multiple channels
                      </p>
                    </div>
                    <div className="flex-1 bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-5180">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-5181">
                        Notion Productivity Bundle
                      </p>
                      <ul className="text-sm text-gray-600 dark:text-[#B0C1BD] space-y-1" data-id="element-5182">
                        <li data-id="element-5183">• Project management system</li>
                        <li data-id="element-5184">• Client CRM template</li>
                        <li data-id="element-5185">• Invoice tracker</li>
                        <li data-id="element-5186">• Content calendar</li>
                      </ul>
                      <p className="mt-3 text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-5187">
                        Complete business management system in one package
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-8" data-id="element-5188">
                <h3 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9] mb-4 flex items-center" data-id="element-5189">
                  <span className="bg-[#2DB489] dark:bg-[#4ED1A0] text-white w-8 h-8 rounded-full flex items-center justify-center mr-3" data-id="element-5190">
                    2
                  </span>
                  Tiered Bundles
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD] mb-4 ml-11" data-id="element-5191">
                  Offer different bundle sizes (small, medium, large) with
                  increasing value at each tier to appeal to different customer
                  segments.
                </p>
                <div className="ml-11 bg-gray-50 dark:bg-[#1A3330] p-5 rounded-lg mb-6" data-id="element-5192">
                  <p className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-3" data-id="element-5193">
                    Example: UI Component Library
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-5194">
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-5195">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-5196">
                        Starter Pack
                      </p>
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5197">
                        50 essential components
                      </p>
                      <p className="text-sm font-medium text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5198">
                        $39
                      </p>
                    </div>
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg border-2 border-[#2DB489] dark:border-[#4ED1A0]" data-id="element-5199">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-5200">
                        Pro Pack
                      </p>
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5201">
                        150 components + design system
                      </p>
                      <p className="text-sm font-medium text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5202">
                        $79
                      </p>
                      <p className="text-xs text-gray-500 dark:text-[#7A8F8A] mt-2" data-id="element-5203">
                        Most popular
                      </p>
                    </div>
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-5204">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-5205">
                        Enterprise Pack
                      </p>
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5206">
                        300+ components + source files
                      </p>
                      <p className="text-sm font-medium text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5207">
                        $129
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-8" data-id="element-5208">
                <h3 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9] mb-4 flex items-center" data-id="element-5209">
                  <span className="bg-[#2DB489] dark:bg-[#4ED1A0] text-white w-8 h-8 rounded-full flex items-center justify-center mr-3" data-id="element-5210">
                    3
                  </span>
                  Cross-Category Bundles
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD] mb-4 ml-11" data-id="element-5211">
                  Combine products from different categories that appeal to the
                  same target audience to increase exposure for your less
                  popular products.
                </p>
                <div className="ml-11 bg-gray-50 dark:bg-[#1A3330] p-5 rounded-lg mb-6" data-id="element-5212">
                  <p className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-3" data-id="element-5213">
                    Example: Creator Bundle
                  </p>
                  <ul className="text-sm text-gray-600 dark:text-[#B0C1BD] space-y-3" data-id="element-5214">
                    <li className="flex items-start" data-id="element-5215">
                      <span className="bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 w-6 h-6 rounded-full flex items-center justify-center mr-2 flex-shrink-0" data-id="element-5216">
                        1
                      </span>
                      <div data-id="element-5217">
                        <p className="font-medium text-gray-700 dark:text-[#C4D1CC]" data-id="element-5218">
                          YouTube Thumbnail Templates
                        </p>
                        <p className="text-gray-500 dark:text-[#7A8F8A]" data-id="element-5219">
                          For video creators
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-5220">
                      <span className="bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 w-6 h-6 rounded-full flex items-center justify-center mr-2 flex-shrink-0" data-id="element-5221">
                        2
                      </span>
                      <div data-id="element-5222">
                        <p className="font-medium text-gray-700 dark:text-[#C4D1CC]" data-id="element-5223">
                          Content Calendar System
                        </p>
                        <p className="text-gray-500 dark:text-[#7A8F8A]" data-id="element-5224">
                          For planning content
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-5225">
                      <span className="bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 w-6 h-6 rounded-full flex items-center justify-center mr-2 flex-shrink-0" data-id="element-5226">
                        3
                      </span>
                      <div data-id="element-5227">
                        <p className="font-medium text-gray-700 dark:text-[#C4D1CC]" data-id="element-5228">
                          Social Media Caption Templates
                        </p>
                        <p className="text-gray-500 dark:text-[#7A8F8A]" data-id="element-5229">
                          For promoting content
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mt-12 mb-6" data-id="element-5230">
                Pricing Strategies for Bundles
              </h2>
              <div className="bg-gray-50 dark:bg-[#1A3330] p-6 rounded-xl mb-8" data-id="element-5231">
                <h3 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9] mb-4" data-id="element-5232">
                  Finding the Right Discount Level
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD] mb-6" data-id="element-5233">
                  The discount you offer on bundles needs to be significant
                  enough to motivate purchase but not so large that it devalues
                  your products or cuts too deeply into your margins.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-5234">
                  <div className="bg-white dark:bg-[#162825] p-5 rounded-lg" data-id="element-5235">
                    <h4 className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-5236">
                      Too Small
                    </h4>
                    <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5237">
                      5-10% discount
                    </p>
                    <div className="flex items-start" data-id="element-5238">
                      <XIcon className="h-5 w-5 text-red-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-5239" />
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD]" data-id="element-5240">
                        Not enough incentive to purchase the bundle
                      </p>
                    </div>
                  </div>
                  <div className="bg-white dark:bg-[#162825] p-5 rounded-lg border-2 border-[#2DB489] dark:border-[#4ED1A0]" data-id="element-5241">
                    <h4 className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-5242">
                      Optimal
                    </h4>
                    <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5243">
                      15-30% discount
                    </p>
                    <div className="flex items-start" data-id="element-5244">
                      <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-5245" />
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD]" data-id="element-5246">
                        Attractive enough to motivate purchase while maintaining
                        value perception
                      </p>
                    </div>
                  </div>
                  <div className="bg-white dark:bg-[#162825] p-5 rounded-lg" data-id="element-5247">
                    <h4 className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-5248">
                      Too Large
                    </h4>
                    <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5249">
                      50%+ discount
                    </p>
                    <div className="flex items-start" data-id="element-5250">
                      <XIcon className="h-5 w-5 text-red-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-5251" />
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD]" data-id="element-5252">
                        May devalue your products and train customers to wait
                        for deep discounts
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white dark:bg-[#162825] p-5 rounded-lg" data-id="element-5253">
                  <p className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-3" data-id="element-5254">
                    Pricing Example:
                  </p>
                  <div className="space-y-3" data-id="element-5255">
                    <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-[#1A3330]" data-id="element-5256">
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5257">
                        Website Template
                      </span>
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5258">
                        $59
                      </span>
                    </div>
                    <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-[#1A3330]" data-id="element-5259">
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5260">
                        Email Template
                      </span>
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5261">
                        $29
                      </span>
                    </div>
                    <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-[#1A3330]" data-id="element-5262">
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5263">
                        Social Media Pack
                      </span>
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5264">
                        $39
                      </span>
                    </div>
                    <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-[#1A3330]" data-id="element-5265">
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5266">
                        Individual Total
                      </span>
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5267">
                        $127
                      </span>
                    </div>
                    <div className="flex items-center justify-between font-medium" data-id="element-5268">
                      <span className="text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5269">
                        Bundle Price (20% off)
                      </span>
                      <span className="text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5270">
                        $99
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border-t border-gray-200 dark:border-[#1A3330] pt-10 mt-10" data-id="element-5271">
                <h2 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-6" data-id="element-5272">
                  Case Study: Successful Bundle Strategy
                </h2>
                <div className="bg-gray-50 dark:bg-[#1A3330] rounded-xl p-6 mb-8" data-id="element-5273">
                  <div className="flex items-center mb-4" data-id="element-5274">
                    <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-5275">
                      <img src="https://randomuser.me/api/portraits/men/41.jpg" alt="James Cooper" className="w-full h-full object-cover" data-id="element-5276" />
                    </div>
                    <div data-id="element-5277">
                      <h3 className="font-medium text-gray-800 dark:text-[#F8FAF9]" data-id="element-5278">
                        James Cooper
                      </h3>
                      <p className="text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-5279">
                        UI Kit Creator
                      </p>
                    </div>
                  </div>
                  <p className="text-gray-600 dark:text-[#B0C1BD] mb-4" data-id="element-5280">
                    "I had been selling individual UI component packs for
                    different purposes - dashboards, e-commerce, and mobile
                    apps. Each was priced at $49 and sold moderately well. After
                    analyzing my sales data, I noticed many customers would
                    eventually buy more than one pack."
                  </p>
                  <p className="text-gray-600 dark:text-[#B0C1BD] mb-4" data-id="element-5281">
                    "I decided to create a 'Complete UI System' bundle that
                    included all three packs plus a bonus style guide template.
                    I priced it at $119 (a 20% discount off buying separately).
                    Within the first month, the bundle became my best-selling
                    product, and my overall revenue increased by 35%."
                  </p>
                  <div className="mt-6 grid grid-cols-2 gap-4 text-center" data-id="element-5282">
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-5283">
                      <p className="text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-5284">
                        Before Bundling
                      </p>
                      <p className="text-xl font-bold text-gray-700 dark:text-[#C4D1CC]" data-id="element-5285">
                        $3,500/month
                      </p>
                    </div>
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-5286">
                      <p className="text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-5287">
                        After Bundling
                      </p>
                      <p className="text-xl font-bold text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5288">
                        $4,725/month
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-[#0D3C45]/5 dark:bg-[#0D3C45]/20 rounded-xl p-6 mt-12" data-id="element-5289">
                <h2 className="text-xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-4" data-id="element-5290">
                  Key Takeaways
                </h2>
                <ul className="space-y-3" data-id="element-5291">
                  <li className="flex items-start" data-id="element-5292">
                    <div className="bg-[#2DB489] dark:bg-[#4ED1A0] rounded-full p-1 mr-3 mt-1 flex-shrink-0" data-id="element-5293">
                      <CheckIcon className="h-3 w-3 text-white" data-id="element-5294" />
                    </div>
                    <p className="text-gray-700 dark:text-[#B0C1BD]" data-id="element-5295">
                      Bundle complementary products that solve a larger problem
                      for your customers
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-5296">
                    <div className="bg-[#2DB489] dark:bg-[#4ED1A0] rounded-full p-1 mr-3 mt-1 flex-shrink-0" data-id="element-5297">
                      <CheckIcon className="h-3 w-3 text-white" data-id="element-5298" />
                    </div>
                    <p className="text-gray-700 dark:text-[#B0C1BD]" data-id="element-5299">
                      Aim for a 15-30% discount to make bundles attractive while
                      maintaining value perception
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-5300">
                    <div className="bg-[#2DB489] dark:bg-[#4ED1A0] rounded-full p-1 mr-3 mt-1 flex-shrink-0" data-id="element-5301">
                      <CheckIcon className="h-3 w-3 text-white" data-id="element-5302" />
                    </div>
                    <p className="text-gray-700 dark:text-[#B0C1BD]" data-id="element-5303">
                      Create tiered bundles to appeal to different customer
                      segments and budgets
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-5304">
                    <div className="bg-[#2DB489] dark:bg-[#4ED1A0] rounded-full p-1 mr-3 mt-1 flex-shrink-0" data-id="element-5305">
                      <CheckIcon className="h-3 w-3 text-white" data-id="element-5306" />
                    </div>
                    <p className="text-gray-700 dark:text-[#B0C1BD]" data-id="element-5307">
                      Clearly communicate the value and savings of your bundle
                      compared to buying products individually
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            {/* Related resources */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm mb-10" data-id="element-5308">
              <h2 className="text-xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-6" data-id="element-5309">
                Related Resources
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5310">
                <a href="/learn/pricing-strategies" className="group block bg-gray-50 dark:bg-[#1A3330] rounded-lg p-5 transition-all hover:shadow-md" data-id="element-5311">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2 group-hover:text-[#2DB489] dark:group-hover:text-[#4ED1A0] transition-colors" data-id="element-5312">
                    Pricing Your Digital Products
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5313">
                    Learn proven strategies for pricing your digital products to
                    maximize sales and revenue.
                  </p>
                  <div className="flex items-center text-[#2DB489] dark:text-[#4ED1A0] text-sm font-medium" data-id="element-5314">
                    <span data-id="element-5315">Read more</span>
                    <ArrowRightIcon className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-5316" />
                  </div>
                </a>
                <a href="/learn/limited-offers" className="group block bg-gray-50 dark:bg-[#1A3330] rounded-lg p-5 transition-all hover:shadow-md" data-id="element-5317">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2 group-hover:text-[#2DB489] dark:group-hover:text-[#4ED1A0] transition-colors" data-id="element-5318">
                    Creating Limited-Time Offers
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5319">
                    Strategies for creating urgency and scarcity to boost sales
                    of your digital products.
                  </p>
                  <div className="flex items-center text-[#2DB489] dark:text-[#4ED1A0] text-sm font-medium" data-id="element-5320">
                    <span data-id="element-5321">Read more</span>
                    <ArrowRightIcon className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-5322" />
                  </div>
                </a>
              </div>
            </div>
            {/* CTA */}
            <div className="bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 text-white text-center" data-id="element-5323">
              <h2 className="text-2xl font-bold mb-4" data-id="element-5324">
                Ready to create your own product bundles?
              </h2>
              <p className="text-lg opacity-90 mb-6 max-w-2xl mx-auto" data-id="element-5325">
                Apply these bundle strategies to your digital products and start
                increasing your average order value today.
              </p>
              <a href="/sell-product" className="inline-block bg-white text-[#0D3C45] px-6 py-3 rounded-lg font-medium hover:bg-opacity-90 transition-all" data-id="element-5326">
                Start Selling
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-5327" />
    </div>;
};